module.exports = __webpack_public_path__ + "media/application/images/icons/logo-c79fc6725220c3c481bc9bb484f7ac3c.svg";